<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addStartInfos">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('startInfos')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";
import { API_HELPER } from "@/helpers/api.js";

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'title', label: i18n.t('title'), _classes: 'font-weight-bold', sortable: true },
        { key: 'photo', label: i18n.t('photo') },
        { key: 'buttonPrimary', label: i18n.t('buttonPrimary'), sortable: true }
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'id', asc: false },
      loading: false
    }
  },
  computed: {
    ...mapState('startInfos', ['getStartInfosOutput']),
    ...mapState('startInfos', ['deleteStartInfoByIdOutput']),
    startInfosInfo: function() {
      return this.getStartInfosOutput ? this.getStartInfosOutput : null;
    },
    items: function()
    {
      var result = [];

      if(this.startInfosInfo && this.startInfosInfo.data)
      {
        result = this.startInfosInfo.data;

        result.forEach(startInfo =>
        {
          startInfo.photo = API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, startInfo.photoPath]);
        });
      }
      
      return result;
    },
    pages: function()
    {
      return this.startInfosInfo ? this.startInfosInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('startInfos', ['getStartInfos']),
    ...mapActions('startInfos', ['deleteStartInfoById']),
    rowClicked (item, index) {
      this.$router.push({name: "StartInfosEdit", query: { id: item.id }, params : { name: `${item.firstName} ${item.lastName}` } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "StartInfosEdit", query: { id: item.id }, params : { name: `${item.firstName} ${item.lastName}` } });
          break;
        }
        case 'remove':
        {
          if(confirm(this.$i18n.tc('confirmRemove', `${item.firstName} ${item.lastName}`, { name: `${item.firstName} ${item.lastName}` }))){
            this.deleteStartInfoById(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));

      this.getStartInfos(input); 
    },
    addStartInfos () 
    {
      router.push({ name: 'StartInfosAdd'});
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteStartInfoByIdOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getStartInfosOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 